<template>
  <div
    class="research-directions-banner d-flex justify-center py-2 py-lg-1 px-5 px-md-10"
    :style="{ backgroundImage: `url(${images.bannerBackgroundTop})` }"
  >
    <LayoutGutters :no-padding="true" :no-gutters="true">
      <v-row class="research-directions-banner__row" align="center">
        <v-col cols="11" lg="8">
          <span class="inverted--text"
            >This community is part of Research Directions - a journal
            collection based around cutting edge research questions.</span
          >
        </v-col>
        <v-col class="mx-3">
          <v-row justify="space-between" align="center">
            <v-btn
              class="research-directions-banner__button focused inverted--text px-6 py-2"
              :href="researchDirectionsUrl"
              aria-label="Learn More about Research Directions [opens in a new tab]"
              target="_blank"
            >
              Learn More
            </v-btn>

            <img
              :src="images.logo"
              alt="Research directions logo"
              class="py-2"
            />
          </v-row>
        </v-col>
      </v-row>
    </LayoutGutters>
  </div>
</template>

<script>
import { mapState } from "vuex";

import LayoutGutters from "~/components/layout/LayoutGutters.vue";

export default {
  name: "ResearchDirectionsBannerTop",
  components: {
    LayoutGutters,
  },
  data() {
    return {
      researchDirectionsUrl:
        "https://www.cambridge.org/core/what-we-publish/collections/research-directions",
    };
  },
  computed: {
    ...mapState({
      images: (state) => state.theme.images.researchDirections,
    }),
  },
};
</script>

<style scoped lang="scss">
.research-directions-banner {
  background-size: cover;

  &__row {
    max-width: 1380px;
  }

  &__button {
    box-shadow: none;
  }
}
</style>
